/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_RATING': {
    width: 16,
    height: 16,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M13.76 17L8.5 14.09 3.24 17l1-6.15L0 6.51l5.84-.89L8.5 0l2.64 5.62 5.86.89-4.22 4.34zM8.5 13.09l4.11 2.27-.79-4.81 3.35-3.43-4.62-.71L8.5 2.06l-2 4.35-4.63.71 3.35 3.43-.79 4.81z" _fill="#545454"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_RATING.js